// @flow

import type { State } from './reducers';
import type { BlogItem } from '../../types';

type GlobalState = {
  blog: State,
};

const getReducer = (state: GlobalState): State => state.blog;

// when offset is 0 it returns all items and when > 1 it slices off the first item(s)
export const getBlogItems = (state: GlobalState, offset?: number = 0): Array<BlogItem> => (
  getReducer(state).items.slice(offset)
);

export const getHighlightedItem = (state: GlobalState): BlogItem => (
  getReducer(state).items[0]
);

export const getLoadMoreLink = (state: GlobalState): ?string => (
  getReducer(state).links['load-more']
);
